export default {
  tax: {
    en: 'Tax',
  },

  product: {
    first: {
      en: 'First product',
    },
    monthlySubscription: {
      en: 'Monthly subscription',
    },
    monthSubscription: {
      en: '{months}-Month subscription',
    },
    threeMonth: {
      en: '3 month of fragrance',
    },
    giftCard: {
      en: 'Gift card',
    },
    giftSubscription: {
      en: 'Gift subscription',
    },
    free: {
      en: 'FREE',
    },
    freeProduct: {
      en: 'Free Product',
    },
    freeTrial: {
      en: 'First product',
    },
  },

  shipping: {
    common: {
      en: 'Shipping',
    },
    subscription: {
      en: 'Subscription shipping',
    },
    ecommerce: {
      en: 'Ecommerce shipping',
    },
  },

  discount: {
    common: {
      en: 'Discount',
    },
    subscription: {
      en: 'Subscription discount',
    },
    ecommerce: {
      en: 'Ecommerce discount',
    },
    secondMonthFree: {
      en: '2nd Month\'s {gender, select, female {Perfume} male {Cologne}}',
    },
    thirdMonthFree: {
      en: 'Subscription 1st month free',
    },
    resubscribe: {
      en: 'Discount (Next {months} Months)',
    },
    resubscribe50: {
      en: 'Discount (This Month)',
    },
  },

  credits: {
    ecommerce: {
      en: 'Ecommerce gift credit (Balance)',
    },
  },

  redeemCoupon: {
    ecommerceCredit: {
      en: 'Ecommerce credit',
    },
    creditCardAuthorization: {
      en: 'Card authorization',
    },
    payPalAuthorization: {
      en: 'PayPal authorization',
    },
    nextMonth: {
      en: 'Next month',
    },
  },

  tossInNote: {
    en: '<b>NOTE:</b> all products will be delivered with your monthly subscription shipment.',
  },
  free: {
    en: 'FREE',
  },
  paid: {
    en: 'PAID',
  },

  upcharge: {
    label: {
      en: 'Premium upcharge',
    },
    note: {
      en: 'Full-size product',
    },
  },
}
